import React from 'react';

function BrokenImage() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g fill="currentColor" fillOpacity=".6">
        <path d="M22.045 17.5c0 .827-.642 1.5-1.431 1.5H4.386c-.789 0-1.431-.673-1.431-1.5v-11c0-.827.642-1.5 1.431-1.5h16.228c.789 0 1.431.673 1.431 1.5v11zM20.614 4H4.386C3.07 4 2 5.121 2 6.5v11C2 18.879 3.07 20 4.386 20h16.228C21.93 20 23 18.879 23 17.5v-11C23 5.121 21.93 4 20.614 4zm-7.591 8.25l2.35 2.35a.5.5 0 0 1 0 .707l-.066.066a.5.5 0 0 1-.707 0l-2.35-2.35-2.35 2.35a.5.5 0 0 1-.707 0l-.066-.066a.5.5 0 0 1 0-.707l2.35-2.35-2.35-2.35a.5.5 0 0 1 0-.707l.066-.066a.5.5 0 0 1 .707 0l2.35 2.35 2.35-2.35a.5.5 0 0 1 .707 0l.066.066a.5.5 0 0 1 0 .707l-2.35 2.35z" />
      </g>
    </svg>
  );
}

export default BrokenImage;
